import { render, staticRenderFns } from "./custom-across-roll.vue?vue&type=template&id=a75c08f2"
import script from "./custom-across-roll.vue?vue&type=script&lang=js"
export * from "./custom-across-roll.vue?vue&type=script&lang=js"
import style0 from "./custom-across-roll.vue?vue&type=style&index=0&id=a75c08f2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports